export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderSuggestions@3x.png";